var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"topimg"},[_c('img',{attrs:{"src":_vm.detailData.actCover,"alt":""}})]),_c('div',{staticClass:"content"},[_c('div',{staticClass:"title"},[_vm._v("活动介绍")]),_c('div',{staticClass:"contenttext",domProps:{"innerHTML":_vm._s(_vm.detailData.actExplain)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }